import { Twitter } from '@velocity-exchange/icons';
import Button from 'src/components/primitives/Button/Button';
import usePostHogCapture from 'src/hooks/posthog/usePostHogCapture';

interface Props {
	isCopying: boolean;
	isCopied: boolean;
	handleCopy: () => void;
}

export default function PnlModalCopyButton({
	isCopying,
	isCopied,
	handleCopy,
}: Props) {
	const { captureEvent } = usePostHogCapture();

	const handleClick = () => {
		if (!isCopied) {
			handleCopy();
		}

		captureEvent('pnl_action_performed', {
			action: isCopied ? 'share_on_x' : 'copy',
		});
	};

	if (!isCopied) {
		return (
			<Button
				size="lg"
				variant="secondary"
				className="flex-1"
				onClick={handleClick}
				isLoading={isCopying}
			>
				Copy
			</Button>
		);
	}

	// Once copied, the button becomes a link to share on X.
	const href = `https://x.com/share?url=${encodeURIComponent(
		'https://app.drift.trade'
	)}&text=${encodeURIComponent('Trade with me on @DriftProtocol')}`;

	return (
		<Button
			size="lg"
			variant="secondary"
			className="basis-3/4"
			as="a"
			href={href}
			rightIcon={Twitter}
			onClick={handleClick}
			openInNewTab
		>
			Copied! Share on
		</Button>
	);
}
